import { Card, Skeleton } from 'antd';
import React, { useState, useEffect } from 'react';
import { enmStopFreeSaleReportTypes } from '../../models/enums/StopFreeSaleReportTypes';
import dayjs from 'dayjs';
import { mdlStopFreeSaleReportRequest } from '../../models/service-models/stop-free-sale/StopFreeSaleReportRequest';
import { StopFreeSaleService } from '../../services/StopFreeSaleService';
import { useQuery } from 'react-query';
import _ from 'lodash';
import CookieManager from '../../utils/CookieManager';

const tableStyles = {
  wrapper: {
    width: '100%',
  },
  table: {
    width: '100%',
    tableLayout: 'fixed',
    borderCollapse: 'collapse'
  },
  firstColumns: {
    width: '15%',
  },
  dayColumn: {
    width: `${85 / 31}%`,
  },
  dayCell: {
    padding: '4px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }
} as const;

const StopSaleReport = ({ 
  data,
  agencies,
  markets,
  roomTypes,
  rooms,
  boards,
  reportTypes,
  activeMonth,
  activeYear,
  formValues,
  isLoading
}: {
  data:any;
  agencies: string[];
  markets: string[];
  roomTypes: string[];
  rooms: string[];
  boards: string[];
  reportTypes: enmStopFreeSaleReportTypes[] | undefined;
  activeMonth: number |undefined;
  activeYear: number |undefined;
  formValues: any;
  isLoading: boolean;
}) => {
  const [detailYear, setDetailYear] = useState(null);
  const [detailMonth, setDetailMonth] = useState(null);
  const [expandedMonth, setExpandedMonth] = useState(null);
  const [expandedHotel, setExpandedHotel] = useState(null as any);
  

    const {
      data: detailData,
      isLoading: detailLoading,
      isError,
      refetch
  } = useQuery(
      ["getReportDetail", expandedHotel, detailMonth, detailYear],
      () => {
          if (expandedHotel && activeMonth && activeYear) {
            const _activeMonth = ("00").substring((detailMonth ?? activeMonth).toString().length, 2) + (detailMonth ?? activeMonth).toString();
            const _activeYear = ("0000").substring((detailYear ?? activeYear).toString().length, 4) + (detailYear ?? activeYear).toString();
            const startDate = dayjs(`02.${_activeMonth}.${_activeYear}`,"DD.MM.YYYY");
            const endDate =  dayjs(`02.${_activeMonth}.${_activeYear}`,"DD.MM.YYYY").add(1,"month");
            if(expandedHotel.length > 0 && (!(endDate.isValid()) || !(startDate.isValid())))
              return
            var request: mdlStopFreeSaleReportRequest = { 
                  hotelId: expandedHotel, 
                  agencies: agencies, 
                  markets: markets, 
                  rooms: rooms, 
                  roomTypes: roomTypes, 
                  boards: boards, 
                  stopFreeSaleReportTypes: reportTypes,
                  stopFreeSaleEndDate: endDate.toDate(),
                  stopFreeSaleStartDate: startDate.toDate(),
                  stopFreeSaleStatus: formValues.stopFreeSaleStatus,
            };
            return StopFreeSaleService.GetReportDetail(request);
          }
      },
      {
          refetchOnWindowFocus: false,
          enabled: !!expandedHotel,
      }
  );

  const toggleHotelExpand = async (hotelId:any, month:any, year:any) => {
    setDetailYear(null);
    setDetailMonth(null);
    setExpandedHotel(null);
    setDetailYear(year);
    setDetailMonth(month);
    setExpandedHotel(hotelId);
  };

  return (
    <div className="w-full space-y-4">
      {data?.result?.map((monthData:any, monthIndex:any) => (
        <Card key={`${monthData.year}-${monthData.month}`} className="w-full">
          <div className="flex flex-row items-center justify-between cursor-pointer"
                     onClick={() => setExpandedMonth(expandedMonth === monthIndex ? null : monthIndex)}>
            <h5 className="text-lg font-semibold">
              {new Date(monthData.year, monthData.month - 1).toLocaleString('default', { month: 'long', year: 'numeric' })}
            </h5>
            {expandedMonth === monthIndex ? <i className="fas fa-chevron-up"></i> : <i className="fas fa-chevron-down"></i>}
          </div>
          
            <div style={tableStyles.wrapper}>
              <div className="ant-table-content">
                <table className="custom table" style={tableStyles.table}>
                  <colgroup>
                    <col style={tableStyles.firstColumns} />
                    {Array.from({ length: monthData.daysInMonth }, () => (
                      <col style={tableStyles.dayColumn} />
                    ))}
                  </colgroup>
                  <thead className='ant-table-thead'>
                    <tr>
                      <th className="ant-table-cellborder text-left" style={ {"background": "#fafafa", color: "#000"}}>Hotel</th>
                      {Array.from({ length: monthData.daysInMonth }, (_, i) => (
                        <th key={i + 1} className="ant-table-cell border text-center" style={{...tableStyles.dayCell, "background": "#fafafa", color: "#000"  }}>
                          {new Date(monthData.year, monthData.month - 1, i + 1).toLocaleDateString('default', { weekday: 'short' })}
                          <br />
                          {i + 1}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody className='ant-table-tbody'>
                    {monthData.hotelData.map((hotel:any) => (
                      <React.Fragment key={hotel.hotelId}>
                        <tr className='ant-table-row'>
                          <td className="ant-table-cell border font-medium cursor-pointer"
                              onClick={() => toggleHotelExpand(hotel.hotelId, monthData.month, monthData.year)}>
                            {hotel.hotelName}
                          </td>
                          {hotel.dayStatus.map((day:any, i:any) => (
                            <td key={i} className={`p-0 border text-center ${
                              day.status === 'stopsale' ? 'stop-sale-cell' :
                              day.status === 'freesale' ? 'free-sale-cell' : ''
                            }`}>
                              <span className='day-text'>{day.status !== 'none' && '•'}</span>
                            </td>
                          ))}
                        </tr>
                        
                          {
                              detailLoading ? <>
                                  <tr className='ant-table-row'>
                                    <td className='ant-table-cell p-0' colSpan={monthData.daysInMonth + 1}>
                                      <Skeleton active paragraph={ false}></Skeleton>
                                    </td>
                                  </tr>
                              </> :
                              <>
                              
                                {expandedHotel === `${hotel.hotelId}` && detailData && monthData.month === detailMonth && monthData.year === detailYear && detailData.body?.data &&
                                  <tr className='ant-table-row'>
                                    <td className='ant-table-cell p-0' colSpan={monthData.daysInMonth + 1}>
                                        <DetailView 
                                          data={detailData?.body?.data}
                                          reportTypes={reportTypes}
                                          detailLoading={detailLoading}
                                          tableStyles={tableStyles}
                                        />
                                    </td>
                                  </tr>
                                }
                              </> 
                            }
                      </React.Fragment>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
        </Card>
      ))}
    </div>
  );
};

const DetailView = ({ data, reportTypes, detailLoading, tableStyles }:any) => {
  const columns = [
    ...(reportTypes.includes(enmStopFreeSaleReportTypes.Agency) ? ['Agency'] : []),
    ...(reportTypes.includes(enmStopFreeSaleReportTypes.Market) ? ['Market'] : []),
    ...(reportTypes.includes(enmStopFreeSaleReportTypes.RoomType) ? ['Room Type'] : []),
    ...(reportTypes.includes(enmStopFreeSaleReportTypes.Rooms) ? ['Room'] : []),
    ...(reportTypes.includes(enmStopFreeSaleReportTypes.Board) ? ['Board'] : [])
  ];

  return (
    <div className='ant-table-content p-0' style={tableStyles.wrapper}>
      
        <table className="w-full border-collapse custom-table" style={tableStyles.table}>
          <colgroup>
            {columns.map(() => (
              <col style={tableStyles.firstColumns} />
            ))}
            {Array.from({ length: (_.first(data) as any)?.daysInMonth ?? 0 }, () => (
              <col style={tableStyles.dayColumn} />
            ))}
          </colgroup>
          <thead className='ant-table-thead'>
            <tr>
              {columns.map(col => (
                <th key={col} className="ant-table-cell border text-left">{col}</th>
              ))}
              {Array.from({ length: (_.first(data) as any)?.daysInMonth ?? 0 }, (_, i) => (
                <th key={i} className="ant-table-cell table-day-cell"><span className="text-center d-block">{i + 1}</span></th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((detail:any, i:any) => (
                <tr key={i} className='ant-table-row'>
                {reportTypes.includes(enmStopFreeSaleReportTypes.Agency) && (
                  <td className="ant-table-cell border">{detail.agencyName}</td>
                )}
                {reportTypes.includes(enmStopFreeSaleReportTypes.Market) && (
                  <td className="ant-table-cell border">{detail.marketName}</td>
                )}
                {reportTypes.includes(enmStopFreeSaleReportTypes.RoomType) && (
                  <td className="ant-table-cell border">{detail.roomTypeName}</td>
                )}
                {reportTypes.includes(enmStopFreeSaleReportTypes.Rooms) && (
                  <td className="ant-table-cell border">{detail.roomName}</td>
                )}
                {reportTypes.includes(enmStopFreeSaleReportTypes.Board) && (
                  <td className="ant-table-cell border">{detail.boardName}</td>
                )}
                {detail.dayStatus.map((day:any, j:any) => (
                  <td key={j} className={`detail-day-cell ant-table-cell border text-center table-day-cell ${
                    day.status === 'stopsale' ? 'stop-sale-cell' :
                    day.status === 'freesale' ? 'free-sale-cell' : ''
                  }`}>
                    {day.sendDate && (
                      <span className="day-text">
                        {new Date(day.sendDate).toLocaleString((CookieManager.get("language") ?? "en-US"), {month: 'short'})}<br/>{new Date(day.sendDate).getDate()}
                      </span>
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
    </div>
  );
};

export default StopSaleReport;